import {
  ADD_LINKED_CATEGORIES_SET,
  FETCH_ALL_LINKED_CATEGORIES,
  FETCH_LINKED_CATEGORY_SET_BY_CATEGORY,
  LinkedCategorySetByCategoryRequest,
  LinkedCategorySetByCategoryAction,
  LinkedCategorySetsRequest,
  LinkedCategorySetsRequestAction,
  RESET_UPLOAD_SUCCESS,
  RESET_LINKED_CATEGORY_DATA,
  FETCH_LINKED_CATEGORY_CODES,
  LinkedCategoryEntry,
  SEARCH_LINKED_CATEGORIES,
  CLEAR_LINKED_CATEGORY_SEARCH,
  LinkedCategoryPane,
  LinkedCategorySearchRequest,
  LinkedCategorySearchAction,
  ClearLinkedCategorySearchAction,
} from "./LinkedCategoriesTypes";

export const fetchAllLinkedCategories = () => {
  return {
    type: FETCH_ALL_LINKED_CATEGORIES.REQUEST,
  };
};

export const addLinkedCategorySetsRequest = (
  payload: LinkedCategorySetsRequest,
): LinkedCategorySetsRequestAction => {
  return {
    type: ADD_LINKED_CATEGORIES_SET.REQUEST,
    payload,
  };
};

export const resetUploadSuccess = () => {
  return {
    type: RESET_UPLOAD_SUCCESS,
  };
};

export const fetchLinkedCategorySetByCategory = (
  payload: LinkedCategorySetByCategoryRequest,
): LinkedCategorySetByCategoryAction => {
  return {
    type: FETCH_LINKED_CATEGORY_SET_BY_CATEGORY.REQUEST,
    payload,
  };
};

export const fetchLinkedCategoryCodes = (
  categories: LinkedCategoryEntry[],
) => {
  return {
    type: FETCH_LINKED_CATEGORY_CODES.REQUEST,
    payload: { categories },
  };
};

export const resetLinkedCategoryData = () => {
  return {
    type: RESET_LINKED_CATEGORY_DATA,
  };
};

export const searchLinkedCategories = (
  payload: LinkedCategorySearchRequest,
): LinkedCategorySearchAction => {
  return {
    type: SEARCH_LINKED_CATEGORIES.REQUEST,
    payload,
  };
};

export const clearLinkedCategorySearch = (
  pane: LinkedCategoryPane,
): ClearLinkedCategorySearchAction => {
  return {
    type: CLEAR_LINKED_CATEGORY_SEARCH,
    payload: { pane },
  };
};
